'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('./utils.js');

function createRmAll(client) {
  async function rmAll({timeout, signal, headers, ...query}) {
    await client.post('pin/remote/rm', {
      timeout,
      signal,
      headers,
      searchParams: utils.encodeQuery({
        ...query,
        all: true
      })
    });
  }
  return rmAll;
}

exports.createRmAll = createRmAll;
